import React from "react";
import Calendar from "./components/Calendar";

const App = () => {
  return (
    <div>
      <Calendar />
    </div>
  );
};

export default App;